import React from 'react';

interface IconProps {
  width?: string;
  height?: string;
  hover?: boolean;
  fill?: string;
}

export const AuditOrangeIcon: React.FC<IconProps> = ({
  width = '24px',
  height = '24px',
  hover = true,
  fill = '#037691'
}) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.70706 9.29306C9.52006 9.10506 9.26506 9.00006 9.00006 9.00006H6.00004C5.44803 9.00006 5.00003 9.44806 5.00003 10.0001V13.0001C5.00003 13.2651 5.10503 13.5191 5.29303 13.7071L11.2901 19.7071C11.6801 20.0971 12.3131 20.0981 12.7041 19.7071L15.7071 16.7071C15.8941 16.5201 16.0001 16.2661 16.0001 16.0001C16.0001 15.7351 15.8951 15.4801 15.7071 15.2931L9.70706 9.29306ZM7.00004 12.5861L11.9981 17.5861L13.5851 16.0001L8.58605 11.0001H7.00004V12.5861ZM2.00001 6.00004V14.0001H3.00002C3.55202 14.0001 4.00002 14.4481 4.00002 15.0001C4.00002 15.5521 3.55202 16.0001 3.00002 16.0001H1.00001C0.448003 16.0001 0 15.5521 0 15.0001V1.00001C0 0.448003 0.448003 0 1.00001 0H19.0001C19.5521 0 20.0001 0.448003 20.0001 1.00001V15.0001C20.0001 15.5521 19.5521 16.0001 19.0001 16.0001H18.0001C17.4481 16.0001 17.0001 15.5521 17.0001 15.0001C17.0001 14.4481 17.4481 14.0001 18.0001 14.0001V6.00004H2.00001ZM18.0001 2.00001H6.00004V4.00002H18.0001V2.00001ZM2.00001 2.00001V4.00002H4.00002V2.00001H2.00001Z'
        fill='#F5981E'
      />
    </svg>
  );
};
